<!-- 资产入库下架返回 -->
<template>
  <div class="content">
    <div class="table" v-loading="is_loading">
      <el-table
        key="tableKey"
        ref="tableData"
        :data="pageData"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="onSelect"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
        <el-table-column
          type="selection"
          min-width="40"
          :show-overflow-tooltip="true"
          fixed="left"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="seqId"
          label="序号"
          min-width="65"
          :show-overflow-tooltip="true"
          fixed="left"
          align="center"
        >
        </el-table-column
        ><el-table-column
          prop="assets_type"
          label="资产类型"
          :show-overflow-tooltip="true"
          align="center"
          min-width="120"
        >
        </el-table-column
        ><el-table-column
          prop="mode"
          label="管理方式"
          :show-overflow-tooltip="true"
          min-width="80"
          align="center"
        >
        </el-table-column
        ><el-table-column
          min-width="80"
          prop="manufacturer"
          label="厂商"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column
        ><el-table-column
          prop="pn"
          label="PN"
          :show-overflow-tooltip="true"
          align="center"
          min-width="120"
        >
        </el-table-column
        ><el-table-column
          prop="inLib"
          min-width="90"
          label="逻辑库"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column
        ><el-table-column
          prop="dept_name"
          label="部门"
          min-width="80"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column
        ><el-table-column
          prop="outway"
          label="出库方式"
          min-width="80"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="enabled"
          min-width="80"
          label="是否可用"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="amount"
          label="数量"
          :show-overflow-tooltip="true"
          align="center"
          min-width="70"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="assetId"
          label="固资"
          :show-overflow-tooltip="true"
          align="center"
          min-width="100"
        >
        </el-table-column
        > -->
        <el-table-column
          prop="sn"
          label="SN"
          :show-overflow-tooltip="true"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="Actual_PN"
          label="实际PN"
          :show-overflow-tooltip="true"
          align="center"
          min-width="220"
        >
          <template v-slot="{ row }">
            <el-select
              v-if="row.mode === '计件'"
              :disabled="row.mode === '计件' && !row.isSelect"
              :value="row.Actual_PN"
              :loading="selectLoading"
              @change="(val) => onPnChange(row, val)"
              @focus="getPnlist(row)"
            >
              <el-option
                v-for="(item, index) in pnList"
                :key="index"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="verify"
          label="确认数量"
          :show-overflow-tooltip="true"
          min-width="70"
          align="center"
        >
        </el-table-column
        ><el-table-column
          prop="scan_sn"
          label="扫描SN"
          min-width="140"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template v-slot="{ row, $index }">
            <span v-if="pageData[$index].scan_sn"> {{ pageData[$index].scan_sn }}</span>
          </template> </el-table-column
        ><el-table-column
          prop="asset_bank"
          label="资产库"
          min-width="150"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="asset_shelf"
          label="资产架"
          min-width="100"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="asset_position"
          label="资产位"
          min-width="90"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="isChoice"
          label="是否选择过资产位置"
          min-width="120"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template v-slot="{ row }">
            <template v-if="row.mode === '计量'">
              <el-tag v-if="row.isChoice" type="success">是</el-tag>
              <el-tag v-else type="danger">否</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="outbound_info" label="选择资产位信息" min-width="120" align="center">
          <template v-slot="{ row }">
            <el-button v-if="row.mode === '计量'" @click="showDrawer(row)" type="primary"
              >编辑</el-button
            >
            <div class="location">
              <van-popup
                v-model="row.drawer"
                position="bottom"
                :close-on-click-overlay="false"
                closeable
                lock-scroll
                :z-index="99"
                close-icon-position="top-left"
                get-container="body"
                :style="{ height: '85%', width: '100%' }"
              >
                <van-nav-bar title="选择资产位置信息" />
                <div class="operatingBtn">
                  <div>
                    <h3>申请数量:{{ amounts || '---' }}</h3>
                  </div>

                  <van-button round type="info" size="small" @click="addRow(row)"
                    >新增资产位置信息</van-button
                  >
                </div>
                <van-form @submit="onSubmit">
                  <div v-for="item in formData.locationTable" :key="item.id">
                    <van-cell-group>
                      <van-field
                        v-model="item.position"
                        is-link
                        readonly
                        label="资产位置"
                        name="position"
                        placeholder="请选择资产位置"
                        @click="handleShowCascader(item.id)"
                        :rules="[{ required: true, message: '' }]"
                      />

                      <van-field
                        v-model="item.Actual_PN"
                        is-link
                        readonly
                        label="实际PN"
                        name="Actual_PN"
                        placeholder="请选择实际PN"
                        @click="handleShowPicker(item.id)"
                        :rules="[{ required: true, message: '' }]"
                      />

                      <van-field
                        v-model="item.outbound_quantity"
                        name="outbound_quantity"
                        label="出库数量"
                        type="number"
                        placeholder="请输入出库数量"
                        @blur="onBlur"
                        :rules="[{ required: true, message: '' }]"
                      />
                    </van-cell-group>
                    <div>
                      <van-button type="danger" class="VantBtn" @click="handleDeteleRow(item.id)"
                        >删除</van-button
                      >
                    </div>
                  </div>

                  <van-popup v-model="showCascader" round position="bottom" get-container="body">
                    <van-cascader
                      v-model="cascaderValue"
                      get-container="body"
                      title="请选择资产位置"
                      :options="AssetLocationData"
                      @close="showCascader = false"
                      @finish="onFinish"
                    />
                  </van-popup>

                  <van-popup v-model="showPicker" round position="bottom" get-container="body">
                    <van-picker
                      title="实际PN"
                      show-toolbar
                      :columns="PnList"
                      @confirm="ActualPnConfirm"
                      @cancel="showPicker = false"
                    />
                  </van-popup>

                  <div style="margin: 16px">
                    <van-button round block type="info" native-type="submit">保存</van-button>
                  </div>
                </van-form>
              </van-popup>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.length"
        :current-page="currentPage"
        :page-sizes="pageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getPnList,
  getMachineRoom,
  getAssetLocation,
  saveProcess,
} from '@/api/toStorageTable/index';
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    context: {
      type: Object,
      default: () => ({}),
    },
    toggle: {
      type: Boolean,
      default: false,
    },
    ActualPnList: {
      type: Array,
      default: () => [],
    },
    scan_snVal: {
      type: String,
      default: '',
    },
    initVal: {
      type: Number,
      default: 0,
    },
    is_ReceivedList: {
      type: Array,
      default: () => [],
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
    idcp_name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
      PnList: [],
      pnList: [],
      selectLoading: false,
      quantityStorage: 0,
      currentPage: 1,
      pageSize: [50],
      pageData: [],
      pagerCount: 2,
      direction: 'rtl',
      formData: {
        locationTable: [
          {
            id: 1,
            position: '',
            Actual_PN: '',
            outbound_quantity: '',
          },
        ],
      },
      AssetLocationData: [],
      amounts: '',
      // 出库数量是否达标
      isArrive: false,
      // 当前行出库数量总和
      rowcCounts: 0,
      cascaderLoading: false,
      showPicker: false,
      PickerID: '',
      showCascader: false,
      CascaderID: '',
      position: '',
      cascaderValue: '',
      rowInfo: {},
    };
  },

  watch: {
    value: {
      handler(val) {
        this.$nextTick(() => {
          this.tableData = [...val];
          this.changePage(this.currentPage);
        });
      },
      deep: true,
    },
    toggle: {
      handler() {
        this.$nextTick(() => {
          this.$refs.tableData.clearSelection();
          this.$refs.tableData.doLayout();
          this.tableData = [...this.tableData];
          this.changePage(this.currentPage);
        });
      },
      deep: true,
      immediate: false,
    },

    is_ReceivedList: {
      handler() {
        const is_ReceivedNums = this.tableData.filter((item) => item.scan_sn);
        this.quantityStorage = this.initVal + is_ReceivedNums.length;
        this.$emit('changeQuantityStorage', this.quantityStorage);
      },
      deep: true,
      immediate: false,
    },
    rowcCounts: {
      handler() {
        if (this.rowcCounts > this.amounts) {
          this.isArrive = true;
        } else if (this.rowcCounts < this.amounts) {
          this.isArrive = false;
        } else if ((this.rowcCounts = this.amounts)) {
          this.isArrive = true;
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.$refs.tableData.toggleAllSelection(true);
    this.$emit('selection-change', this.tableData);
  },
  methods: {
    onSelect(val) {
      this.$emit('selection-change', val);
    },
    async onPnChange(row, val) {
      try {
        this.tableData = [...this.tableData];
        const { pn, mode } = row;
        if (!pn) {
          if (mode === '计件') {
            row.scan_sn = this.scan_snVal;
          }
          row.is_add = true;
          row.is_Received = true;
          row.is_PN = true;
          this.$emit('changeReceivedList', this.quantityStorage);
          this.$emit('changeIsaddSn');
        }
        // if (row.is_PN) {
        //   row.pn = val;
        // }
        // 判断是否为新插入的扫描sn
        if (this.scan_snVal) {
          row.scan_sn = this.scan_snVal;
          row.is_add = true;
          this.$emit('changeIsaddSn');
        }
        row.Actual_PN = val;
        row.pn = val;
        this.$emit('change', this.tableData);
      } catch (error) {
        console.log(error);
      }
    },
    // 获取实际PN
    async getPnlist(val) {
      try {
        const { mode, pn, is_PN } = val;
        const pnData = val.original_pn ? val.original_pn.split('|||') : [];
        // 计量无Pn
        if (mode === '计量' && !pn) {
          this.selectLoading = true;
          const data = await getPnList(val, this.context);
          const { result, code } = data;
          if (code === 0) {
            this.pnList = result.map((item) => ({
              label: item,
              value: item,
            }));
            this.selectLoading = false;
          } else {
            this.selectLoading = true;
          }
        } else if (pn) {
          if (is_PN) {
            this.selectLoading = true;
            const data = await getPnList(val, this.context);
            const { result, code } = data;
            if (code === 0) {
              this.pnList = result.map((item) => ({
                label: item,
                value: item,
              }));
              this.selectLoading = false;
            } else {
              this.selectLoading = true;
            }
            return;
          }
          this.selectLoading = false;
          this.pnList = pnData.map((item) => ({
            label: item,
            value: item,
          }));
        } else if (mode === '计件' && !pn) {
          this.selectLoading = false;
          this.pnList = this.ActualPnList.map((item) => ({
            label: item,
            value: item,
          }));
        }
      } catch (error) {
        this.selectLoading = true;
        this.$message.error(error);
      }
    },

    changePage(page) {
      this.currentPage = page;
      const startIndex = (this.currentPage - 1) * this.pageSize[0];
      const endIndex = startIndex + this.pageSize[0];
      this.pageData = this.tableData.slice(startIndex, endIndex);
    },

    handleShowCascader(id) {
      this.showCascader = true;
      this.CascaderID = id;
      this.cascaderValue = '';
    },

    handleShowPicker(id) {
      this.showPicker = true;
      this.PickerID = id;
    },
    ActualPnConfirm(value) {
      const CascaderItem = this.formData.locationTable.filter((item) => item.id === this.PickerID);
      CascaderItem[0].Actual_PN = value;
      this.showPicker = false;
    },

    onFinish({ selectedOptions }) {
      const position = selectedOptions.map((option) => option.text).join(',');
      const CascaderItem = this.formData.locationTable.filter(
        (item) => item.id === this.CascaderID
      );
      CascaderItem[0].position = position;
      this.showCascader = false;
    },
    // 打开抽屉
    showDrawer(row) {
      try {
        // this.showPopup = true
        row.drawer = true;
        this.rowInfo = row;
        this.amounts = row.amount;
        this.formData.locationTable = [...row.outbound_info] || [
          {
            id: 1,
            position: '',
            Actual_PN: '',
            outbound_quantity: 1,
          },
        ];
        this.PnList = row.pn?.split('|||') || [];
        if (this.PnList.length === 1) {
          this.formData.locationTable = this.formData.locationTable.map((item) => {
            return {
              ...item,
              Actual_PN: this.PnList[0],
            };
          });
        }
        this.getMachineRoom();
        this.$emit('change', this.tableData);
      } catch (error) {
        console.log(error);
      }
    },
    // 获取资产位置信息
    async getMachineRoom() {
      try {
        // const { result } = await getMachineRoom(this.idcp_name)
        const { code, result: data } = await getAssetLocation(this.idcp_name);
        if (code === 0) {
          this.AssetLocationData = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSubmit(values) {
      this.rowInfo.outbound_info = this.formData.locationTable;
      let counts = 0;
      for (const item of this.formData.locationTable) {
        counts += Number(item.outbound_quantity || 0);
      }
      if (counts != this.amounts) {
        this.$message({
          duration: 1500,
          message:
            `出库数量为【${counts}】` + `与申请数量【${this.amounts}】不一致,请确认出库数量!`,
          type: 'warning',
        });
        return;
      }

      // 计算多行出库数量
      let allCounts = 0;
      for (const items of this.tableData) {
        if (!Array.isArray(items.outbound_info)) continue;
        for (const item of items.outbound_info) {
          allCounts += Number(item.outbound_quantity || 0);
        }
      }
      // this.showPopup = false
      this.rowInfo.drawer = false;
      // 是否选择资产信息
      this.$set(this.rowInfo, 'isChoice', true);
      this.rowInfo.outbound_info = this.rowInfo.outbound_info.map((item) => {
        return {
          ...item,
          position: item.position.split(','),
        };
      });
      const parameters = {
        asset_data: this.tableData,
        measurementQuantitys: allCounts,
      };
      const { code, msg } = await saveProcess(parameters, this.context.instanceId);
      if (code === 0) {
        this.$emit('changeOutboundQuantity', allCounts);
        this.$emit('change', this.tableData);
        this.$message({
          duration: 1500,
          message: '保存成功',
          type: 'success',
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 添加行
    addRow(row) {
      try {
        // 计算当出库数量总数
        let allCounts = 0;
        for (const item of this.formData.locationTable) {
          allCounts += Number(item.outbound_quantity || 0);
        }
        if (allCounts >= this.amounts) {
          this.$message({
            duration: 1500,
            message: '【出库数量】已达标,无需再新增!',
            type: 'warning',
          });
          return;
        }
        if (this.formData.locationTable.length > 7) {
          this.$message({
            duration: 1500,
            message: '已超过最大新增行数!',
            type: 'warning',
          });
          return;
        }
        this.PnList = row.pn.split('|||') || [];
        const randomId = this.generateRandomId(10);
        const newRow = {
          id: randomId,
          position: '',
          Actual_PN: this.PnList.length === 1 ? this.PnList[0] : '',
          outbound_quantity: 1,
        };
        this.formData.locationTable.push(newRow);
      } catch (error) {
        console.log(error);
      }
    },

    // 生成以随机id
    generateRandomId(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },

    onBlur() {
      // 计算单行出库数量
      let counts = 0;
      for (const item of this.formData.locationTable) {
        counts += Number(item.outbound_quantity || 0);
      }
      this.rowcCounts = counts;
      if (counts > this.amounts) {
        this.isArrive = true;
        this.$message({
          duration: 1500,
          message:
            `出库数量为【${counts}】` + `不能大于申请数量【${this.amounts}】，请确认一下出库数量`,
          type: 'warning',
        });
        return;
      }
    },

    // 删除当前行
    handleDeteleRow(id) {
      this.formData.locationTable = this.formData.locationTable.filter((item) => item.id !== id);
      let counts = 0;
      for (const item of this.formData.locationTable) {
        counts += Number(item.outbound_quantity || 0);
      }
      this.rowcCounts = counts;
    },
  },
};
</script>

<style scoped lang="less">
.content {
  margin: 0;
  padding: 0;

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .location {
    margin-top: 20px;

    .VantBtn {
      width: 100% !important;
    }

    .operatingBtn {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .rowItem {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .tipText {
        margin-right: 3px;
        font-size: 16px;
      }
    }

    .tips {
      display: flex;
      justify-content: start;
    }

    .title {
      font-size: 22px;
    }
  }
}
</style>
